import React, { useEffect, useState } from "react";

type ChangelogEntry = {
  repo: string;
  version: string;
  date: string;
  summary: string;
  body: string;
  url: string;
};

const REPO_LABELS: Record<string, string> = {
  "yourorg/frontend": "Frontend",
  "yourorg/backend": "Backend",
  "yourorg/mobile": "Mobile",
  "yourorg/kit": "Kit",
};

export default function Changelog() {
  const [entries, setEntries] = useState<ChangelogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/changelog.json")
      .then((res) => res.json())
      .then((data) => {
        setEntries(data);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="p-8 text-center">Loading changelog…</div>;

  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-8">Changelog</h1>
      {entries.length === 0 && <div>No changelog entries found.</div>}
      <ul className="space-y-8">
        {entries.map((entry, i) => (
          <li key={entry.url + i} className="border-b pb-6">
            <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
              <span className="font-semibold">{REPO_LABELS[entry.repo] || entry.repo}</span>
              <span>•</span>
              <span>{new Date(entry.date).toLocaleDateString()}</span>
              <span>•</span>
              <a href={entry.url} target="_blank" rel="noopener noreferrer" className="text-sauna-blue underline">
                View on GitHub
              </a>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-mono text-sm bg-gray-100 px-2 py-0.5 rounded">{entry.version}</span>
              <span className="font-semibold">{entry.summary}</span>
            </div>
            {entry.body && (
              <div className="prose prose-sm mt-2" dangerouslySetInnerHTML={{ __html: entry.body.replace(/\n/g, "<br/>") }} />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
} 